import React, { useState } from 'react';
import namkeFallback from '../../assets/namke-fallback.png';

const SkeletonImage = ({
  src,
  alt,
  width = "w-full",
  height = "h-full",
  className = "",
  fallbackSrc = namkeFallback
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  // Déterminer si on doit utiliser rounded ou non
  const useRounded = !className.includes('rounded-none');
  const roundedClass = useRounded ? 'rounded-lg' : '';

  return (
    <div className={`relative ${width} ${height} ${className}`}>
      {/* Skeleton de chargement */}
      {isLoading && (
        <div className={`absolute inset-0 bg-gray-200 animate-pulse ${roundedClass} z-0`}>
          <div className="flex items-center justify-center h-full">
            <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      )}
      
      {/* Image */}
      <img
        src={hasError ? fallbackSrc : src}
        alt={alt}
        className={`${width} ${height} object-cover ${roundedClass} transition-opacity duration-300 relative z-10 ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}
        onLoad={handleLoad}
        onError={handleError}
      />
    </div>
  );
};

export default SkeletonImage;
